<template>
  <div>
    <van-nav-bar title="会员奖励" left-text="" left-arrow @click-left="onClickLeft()" />

    <div style="height:600px;overflow-y:auto;">
      <van-divider content-position="left">专属会员带单奖励</van-divider>
      <div class="tips">
        *温馨提示：每阶段只能领取4单或者8单奖励一次，已经领取4单奖励则无法领取8单奖励，已经领取8单奖励则无法领取4单奖励。<br/>
        领取奖励时间：2025.7.1-7.10、2026.1.1-1.10。
      </div>
      <div style="margin-top:5px;">
        <van-cell-group>
          <van-cell title="当前单量" :value="currentnum" />
        </van-cell-group>
      </div>
      <div style="margin-top:10px;">
        <van-cell-group inset style="margin-top:10px;">
          <van-card price="4单" currency="" title="工具大礼包" desc="一套">
            <template #footer>
              <van-button type="danger" size="small" v-if="isReceive=1&&reward==1" disabled>已领取</van-button>
              <van-button type="danger" size="small" v-else-if="isReceive=1&&reward==2" disabled>已领取8单奖励</van-button>
              <van-button type="danger" size="small" @click="receive(1,4)" v-else>领取</van-button>
            </template>
            <template #thumb>
              <img src="../../assets/draw2025/工具大礼包.png" style="height:88px;width:88px;" alt="">
            </template>
          </van-card>
          <van-card price="8单" currency="" title="工具大礼包剃须刀" desc="一套">
            <template #footer>
              <van-button type="danger" size="small" v-if="isReceive=1&&reward==2" disabled>已领取</van-button>
              <van-button type="danger" size="small" v-else-if="isReceive=1&&reward==1" disabled>已领取4单奖励</van-button>
              <van-button type="danger" size="small" @click="receive(2,8)" v-else>领取</van-button>
            </template>
            <template #thumb>
              <img src="../../assets/draw2025/工具大礼包剃须刀.png" style="height:88px;width:88px;" alt="">
            </template>
          </van-card>
        </van-cell-group>
      </div>

      <!-- <van-divider content-position="left">专属会员签约奖励</van-divider>
      <div style="text-align:center;">
        <img src="../../assets/draw2025/sign_rule.png" style="width:100%;margin-top:2%;" />
      </div>
      <div style="text-align:center;">
        <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" @click="onSign" v-if="issign==0">
          我要签约
        </van-button>
        <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" v-else disabled>
          已签约
        </van-button>
      </div> -->
    </div>


    
    <!-- <van-divider content-position="left">专属会员带单奖励</van-divider>
    <div style="margin-top:5px;">
      <van-cell-group>
        <van-cell title="当前单量" :value="currentnum" />
      </van-cell-group>
    </div>
    <div style="margin-top:10px;">
      <van-cell-group inset style="margin-top:10px;">
        <van-card price="4单" currency="" title="工具大礼包" desc="一套">
          <template #footer>
            <van-button type="danger" size="small" v-if="isReceive=1&&reward==1" disabled>已领取</van-button>
            <van-button type="danger" size="small" v-else-if="isReceive=1&&reward==2" disabled>已领取其他奖品</van-button>
            <van-button type="danger" size="small" @click="receive(1,4)" v-else>领取</van-button>
          </template>
          <template #thumb>
            <img src="../../assets/draw2025/工具大礼包.png" style="height:88px;width:88px;" alt="">
          </template>
        </van-card>
        <van-card price="8单" currency="" title="工具大礼包+剃须刀" desc="一套">
          <template #footer>
            <van-button type="danger" size="small" v-if="isReceive=1&&reward==2" disabled>已领取</van-button>
            <van-button type="danger" size="small" v-else-if="isReceive=1&&reward==1" disabled>已领取其他奖品</van-button>
            <van-button type="danger" size="small" @click="receive(2,8)" v-else>领取</van-button>
          </template>
          <template #thumb>
            <img src="../../assets/draw2025/工具大礼包+剃须刀.png" style="height:88px;width:88px;" alt="">
          </template>
        </van-card>
      </van-cell-group>
    </div>

    <van-divider content-position="left">专属会员签约奖励</van-divider>
    <div style="text-align:center;">
      <img src="../../assets/draw2025/sign_rule.png" style="width:100%;margin-top:2%;" />
    </div>
    <div style="text-align:center;">
      <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" @click="onSign" v-if="issign==0">
        我要签约
      </van-button>
      <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" v-else disabled>
        已签约
      </van-button>
    </div> -->
    

  </div>
</template>

<script>
import { Button, Card, Cell,CellGroup, NavBar, Dialog, RadioGroup, Radio, Divider } from "vant";
export default {
  data() {
    return {
      fileUrl: this.$file.url,
      prizeList: [],
      currentnum: 0,
      reward:0,
      isReceive:0,
      issign:0,
      isAddr:0,
    };
  },
  props: {},
  created() {
    this.GetActivityPeriod();
    this.GetSDWorkerSign();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    GetActivityPeriod() {
      var that = this;
      this.$http.get("Activity2025/GetMemReward", {
        params: {
          period: 2,
        },
      }).then((res) => {
        that.currentnum = res.data.Data.ProcessNum;
        that.reward = res.data.Data.Current;
        that.isReceive = res.data.Data.IsReceive;
        that.isAddr = res.data.Data.IsAddr;
      });
    },

    GetSDWorkerSign() {
      var that = this;
      this.$http.get("Activity2025/GetSDWorkerSign", {
        params: {},
      }).then((res) => {
        that.issign = res.data.Data.isSign;
      });
    },
    
    // 领取
    receive(id,num) {
      var that = this;
      if(that.currentnum < num)
      {
        return this.$toast.fail("当前单量不足无法领取奖励，请重新选择");
      }
      if(that.isAddr == 0){
        return this.$toast.fail("您的地址未填写，请先前往【个人中心】-【收货地址】填写地址！");
      }
      Dialog.confirm({
        title: "奖励领取",
        message:
          "每个阶段只可领取一次，是否确认领取该奖品，领取成功后无法更换?",
      }).then(() => {
        // on confirm
        that.$http.get("Activity2025/MemberReceive", {
          params: {
            prizeId:id,
            num:num
          },
        }).then((res) => {
          if (res.data == "success") {
            that.$toast("领取成功！请耐心等待奖品配送");
            that.$router.push({
              name: "PrizeAddrs",
              params: {},
            });
            // that.GetActivityPeriod();            
          } else {
            that.$toast(res.data);
          }
        });
      })
      .catch(() => {
        // on cancel
      });
    },
    onSign() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "Sign",
        params: {},
      });
    },
    onConvertLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "ConvertList",
        params: {},
      });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  // mounted() {
  //   this.GetActivityPeriod();
  // },
  components: {
    [NavBar.name]: NavBar,
    [Card.name]: Card,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Dialog.name]: Dialog,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Divider.name]: Divider,
  },
};

</script>

<style scoped>
.aui-take-item {
  background: #fff;
  border-radius: 5px;
  margin: 0.5rem;
}

.aui-flex {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 5px;
  position: relative;
}

.aui-flex-box {
  -webkit-box-flex: 1;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}
.tips {
  font-size: 15px;
  color: red;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
}
</style>